<!-- Auction Transport Fee Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Auction Transport Fee Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-auction-transport-fee-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span>Search</span>
        </button>

        <!-- Add Auction Transport Fee Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddAuctionTransportFeeModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Auction Transport Fee
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-auction-transport-fee-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span data-kt-auction-transport-fee-table-select="selected_count">{{ selectedAuctionTransportFees.length }}</span> Selected
        </div>
        <button type="button" class="btn btn-danger" (click)="deleteSelectedAuctionTransportFees()" data-kt-auction-transport-fee-table-select="delete_selected">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="card-body border-bottom py-4" *ngIf="showFiltersForm" [@slideInOut]>
    <div class="row g-4">
      <div class="col-md-4">
        <label class="form-label fw-semibold text-gray-600 fs-7">Search Auction Transport Fees</label>
        <div class="d-flex align-items-center position-relative">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-3">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input
            type="text"
            class="form-control form-control-sm ps-10"
            placeholder="Search auction transport fees..."
            [(ngModel)]="searchTerm"
            (keyup.enter)="applyFilters()"
          />
        </div>
      </div>
      <div class="col-md-8 d-flex align-items-end">
        <button type="button" class="btn btn-sm btn-primary me-2" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_auction_transport_fees_table">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-25px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-200px">Auction Hall</th>
            <th class="min-w-125px">Auction Fee</th>
            <th class="min-w-125px">Transport Fee</th>
            <th class="min-w-125px">EAA Transport Fee</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let auctionTransportFee of auctionTransportFees; trackBy: trackByFn">
            <td class="text-center pe-0">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [value]="auctionTransportFee._id"
                  [checked]="isSelected(auctionTransportFee._id)"
                  (change)="toggleSelection(auctionTransportFee._id, $event)">
              </div>
            </td>
            <td class="ps-2">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ auctionTransportFee.auction_hall?.company_name || 'N/A' }}</span>
                </div>
              </div>
            </td>
            <td>
              <span class="text-dark fw-semibold">{{ auctionTransportFee.auction_fee || 0 | currency:'JPY':'symbol':'1.0-0' }}</span>
            </td>
            <td>
              <span class="text-dark fw-semibold">{{ auctionTransportFee.transport_fee || 0 | currency:'JPY':'symbol':'1.0-0' }}</span>
            </td>
            <td>
              <span class="text-dark fw-semibold">{{ auctionTransportFee.eaa_transport_fee || 0 | currency:'JPY':'symbol':'1.0-0' }}</span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end gap-2">
                <!-- Edit Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-primary"
                  (click)="openEditModal(auctionTransportFee)"
                  title="Edit Auction Transport Fee">
                  <i class="ki-duotone ki-pencil fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Icon -->
                <button
                  type="button"
                  class="btn btn-sm btn-icon btn-light-danger"
                  (click)="deleteAuctionTransportFee(auctionTransportFee)"
                  title="Delete Auction Transport Fee">
                  <i class="ki-duotone ki-trash fs-5">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
          <!-- Empty State -->
          <tr *ngIf="auctionTransportFees.length === 0">
            <td colspan="6" class="text-center py-10">
              <div class="d-flex flex-column align-items-center">
                <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-muted fs-6">No auction transport fees found</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && auctionTransportFees.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Auction Transport Fee Add/Edit Modal -->
<app-add-edit-auction-transport-fee
  (auctionTransportFeeAdded)="onAuctionTransportFeeAdded()"
  (auctionTransportFeeUpdated)="onAuctionTransportFeeUpdated()">
</app-add-edit-auction-transport-fee>
